
import { defineComponent } from "vue";
import { useTaxonomies } from "@slks/core";

import {
    FooterComponent,
    MainHeader,
    //  SkipNavigation
} from "@/shared/components";

export default defineComponent({
    components: {
        FooterComponent,
        MainHeader,
        // SkipNavigation,
    },
    created() {
        this.$store.dispatch("setLoader", true);
        this.getAllTaxonomies().then((res) => {
            const taxonomies = Array.prototype.concat(...res.map((r) => r.data["hydra:member"]));
            this.$store.dispatch("setTaxonomies", taxonomies);
            this.$store.dispatch("setLoader", false);
        });
    },
    setup() {
        const { getAllTaxonomies } = useTaxonomies();

        return { getAllTaxonomies };
    },
});
